var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnavailableRobotBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 215,
    viewBox: "0 0 222 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "zwhin2s71a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 222,
    height: 224
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 224,
    rx: 10,
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zwhin2s71a)",
    stroke: "#DDE9FF",
    strokeWidth: 14,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.336 60.648-35.75 9.58 27.623 103.091 161.927-43.388-27.623-103.092-36.276 9.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69 83.067c15.284-4.095 24.353-19.804 20.258-35.088-4.095-15.283-19.804-24.353-35.088-20.258-15.283 4.096-24.353 19.805-20.258 35.088 4.096 15.283 19.805 24.353 35.088 20.258zM80.339 165.884c-3.947-30.6 12.076-59.123 38.793-66.282 26.717-7.158 54.795 9.497 66.711 37.91M64.605 219.585l-5.558-20.742 43.414-11.633 2.173 8.11 72.988-19.557-2.173-8.11 45.525-12.198 5.558 20.742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.588 142.135-70.783 18.966 9.118 34.03 70.783-18.967-9.118-34.029z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableRobotBg);
export default __webpack_public_path__ + "static/media/unavailableRobotBG.87caf7a1.svg";
export { ForwardRef as ReactComponent };